<template>
  <div>
    <template v-if="isImg">
      <div
        v-for="(item,index) in uploadList"
        :key="index"
        class="demo-upload-list"
      >
        <img :src="item">
        <div class="demo-upload-list-cover">
          <Icon
            type="ios-trash-outline"
            @click.native="handleRemove(index)"
          ></Icon>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in uploadList"
        :key="index"
        class="demo-upload-list-box"
      >
        <span style="vertical-align: middle; display:inline-block;">
          <!--<Icon type="ios-cloud-done-outline" />-->
          <!--<Icon type="ios-document" />-->
          <!--<Icon type="ios-document-outline"-->
          <!--size="20"></Icon>-->
          <span v-if="showUploadUrl">{{ item }}</span>
          <span v-else>已上传</span>
        </span>
        <span style="vertical-align: middle; margin-left:10px; display:inline-block; cursor: pointer;">
          <Icon
            type="ios-trash-outline"
            size="20"
            @click.native="handleRemove(index)"
          ></Icon>
        </span>
      </div>
    </template>
    <Upload
      v-if="uploadList.length !== limitNum"
      ref="upload"
      :multiple="multiple"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      :on-exceeded-size="handleMaxSize"
      :on-format-error="handleFormatError"
      :disabled="disabled"
      :format="format"
      :accept="accept"
      :max-size="maxSize"
      type="drag"
      :data="params"
      :action="pathRewrite(url)"
      :headers="headers"
      style="display: inline-block;width:58px;"
      :class="{uploadDisabled:disabled,uploadabled:!disabled}"
    >
      <div style="width: 58px;height:58px;line-height: 58px;">
        <Icon
          v-if="isImg"
          type="ios-camera"
          size="20"
        ></Icon>
        <Icon
          v-else
          type="ios-cloud-upload"
          size="20"
        ></Icon>
      </div>
    </Upload>
  </div>
</template>
<script>
export default {
  props: {
    limitNum: {
      type: Number,
      default: 1,
    },
    maxSize: {
      type: Number,
      default: 1024 * 5,
    },
    value: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    format: {
      type: Array,
      default() {
        return ['jpg', 'jpeg', 'png', 'gif'];
      },
    },
    accept: {
      type: String,
      default: '.jpg,.jpeg,.png,.gif',
    },
    url: {
      type: String,
      default: '/paycenter-facade/api/shop/upload',
    },
    fieldName: {
      type: String,
      default: 'fileUrl',
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showUploadUrl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      uploadList: [],
      isImg: true,
      duration: 4,
      headers: {
        token: this.$cookies.get('openPlatformToken'),
      },
    };
  },
  watch: {
    value: {
      handler(value) {
        this.format.forEach(element => {
          if (element === 'jpg' || element === 'jpeg' || element === 'png' || element === 'gif') {
            this.isImg = true;
          } else {
            this.isImg = false;
          }
        });
        if (value) {
          this.uploadList = value.split(',');
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleRemove(index) {
      this.uploadList.splice(index, 1);
      this.$emit('input', this.uploadList.join(','));
      this.$emit('on-remove', this.uploadList.join(','), this.fieldName);
      this.dispatch('FormItem', 'on-form-change', this.uploadList.join(','));
    },
    handleSuccess(res) {
      if (res.success) {
        this.uploadList.push(res.data);
        this.$emit('input', this.uploadList.join(','));
        this.$emit('on-success', this.uploadList.join(','), this.fieldName);
        this.dispatch('FormItem', 'on-form-change', this.uploadList.join(','));
      } else {
        this.$Message.error({
          content: res.message || '上传失败，请重新上传',
          duration: this.duration,
        });
      }
    },
    handleError(res) {
      this.$Message.error({
        content: res.message || '上传失败，请重新上传',
        duration: this.duration,
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < this.limitNum;
      if (!check) {
        this.$Message.error({
          content: `上传的照片不能超过${ this.limitNum }张`,
          duration: this.duration,
        });
      }
      if (this._events.beforeUpload) {
        this.$emit('beforeUpload', this.params);
      }
      return check;
    },
    handleMaxSize(file) {
      this.$Message.error({
        content: `文件  ${ file.name } 过大, 不能超过 ${this.maxSize / 1024}M`,
        duration: this.duration,
      });
    },
    handleFormatError(file) {
      this.$Message.error({
        content: `文件  ${ file.name } 类型不正确!`,
        duration: this.duration,
      });
    },
  },
};
</script>
<style>
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.demo-upload-list-box span .icon-music {
  margin-right: 10px;
  vertical-align: middle;
}
.uploadDisabled{
  color: #ccc;
}
.uploadabled{
  /*border: 1px dashed #aef090;*/
  color: #2d8cf0;
}
</style>
